import request from '../../request'
import { QUERY_CURRENT_USER } from '../../queryKeys/currentUser'
import { queryClient } from '../../queryClient'
import { useMutation } from 'react-query'

const useSetCurrentUserActiveInstitution = () =>
  useMutation(
    (institutionId) => {
      const params = {
        institution: institutionId,
      }
      return request({ endpoint: '/users/me', params })
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries()
        queryClient.setQueryData(QUERY_CURRENT_USER, data)
      },
    }
  )

export default useSetCurrentUserActiveInstitution
